// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   MdSearch,
//   MdClear,
//   MdDownload,
//   MdChevronLeft,
//   MdChevronRight,
//   MdFirstPage,
//   MdLastPage,
// } from "react-icons/md";
// import BulkImportButton from "components/common/BulkImportButton";

// import { deleteProduct, getProductByCompany } from "api/product.api";
// import ProductsTable from "components/products/ProductsTable";

// export default function Products() {
//   const [data, setData] = useState([]);
//   const [alert, setAlert] = useState("");

//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//    const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );
//   const userId = "69579c6190a653b640e65639";

//   const fetchData = async () => {
//     const res = await getProductByCompany(selectedOrganizer || undefined);
//     setData(Array.isArray(res.data?.data) ? res.data.data : []);
//   };

//   useEffect(() => {
//     fetchData();
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };
//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   const handleDelete = async (id) => {
//     await deleteProduct(id, {
//       is_deleted: true,
//       deleted_by: userId,
//     });

//     setAlert("Product deleted successfully");
//     fetchData();
//   };

//   const filteredData = data.filter(
//     (item) =>
//       item.product_name?.toLowerCase().includes(search.toLowerCase()) ||
//       item.status?.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredData.length / limit);

//   const paginatedData = filteredData.slice(
//     (page - 1) * limit,
//     page * limit
//   );

//   const exportCSV = () => {
//     const headers = ["Product Name", "Price", "Exhibitor", "Product Category","Status"];

//     const rows = filteredData.map((p) => [
//       p.product_name,
//       p.price || "-",
//       p.exhibitor_id?.title || "-",
//       p.product_category_id?.title || "-",
//       p.status,
//     ]);

//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       [headers, ...rows].map((r) => r.join(",")).join("\n");

//     const link = document.createElement("a");
//     link.href = encodeURI(csvContent);
//     link.download = "products.csv";
//     link.click();
//   };

//   return (
//     <div className="p-4">

//       <div className="flex justify-between items-center mb-4">
//         <div className="flex items-center gap-2">

//           <div className="relative">
//             <MdSearch className="absolute left-3 top-2.5 text-gray-400 text-lg" />
//             <input
//               type="text"
//               placeholder="Search products..."
//               value={search}
//               onChange={(e) => {
//                 setSearch(e.target.value);
//                 setPage(1);
//               }}
//               className="pl-10 pr-8 py-2 border rounded-md text-sm w-64 focus:outline-none focus:ring-1 focus:ring-brand-500"
//             />

//             {search && (
//               <button
//                 onClick={() => setSearch("")}
//                 className="absolute right-2 top-2.5 text-gray-400 hover:text-gray-600"
//               >
//                 <MdClear />
//               </button>
//             )}
//           </div>

//           <button
//             onClick={exportCSV}
//             className="flex items-center gap-1 px-2 py-1 bg-green-500 text-white rounded-lg"
//           >
//             <MdDownload />
//             CSV
//           </button>
//         </div>

//         <div className="flex items-center gap-2">
//           <BulkImportButton module="products" label="Import Products" onSuccess={fetchData} companyId={selectedOrganizer} />
//         <Link
//           to="/admin/products/create"
//           className="bg-brand-500 hover:bg-brand-600 text-white px-4 py-2 rounded-md text-sm font-medium"
//         >
//           Add Product
//         </Link>
//       </div>
//       </div>

//       <div className="bg-white rounded-md shadow-sm border">
//         <ProductsTable
//           data={paginatedData}
//           onRefresh={fetchData}
//           onDelete={handleDelete}
//         />

//         <div className="flex justify-between items-center px-4 py-3 border-t text-sm">
//           <span className="text-gray-500">
//             {filteredData.length} total
//           </span>

//           <div className="flex items-center gap-1">
//             <select
//               value={limit}
//               onChange={(e) => {
//                 setLimit(Number(e.target.value));
//                 setPage(1);
//               }}
//               className="border rounded-md px-2 py-2 text-sm"
//             >
//               <option value={10}>10 / page</option>
//               <option value={25}>25 / page</option>
//               <option value={50}>50 / page</option>
//             </select>

//             <button
//               disabled={page === 1}
//               onClick={() => setPage(1)}
//               className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdFirstPage />
//             </button>

//             <button
//               disabled={page === 1}
//               onClick={() => setPage(page - 1)}
//               className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdChevronLeft />
//             </button>

//             <span className="px-3 font-medium">
//               {page} / {totalPages || 1}
//             </span>

//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(page + 1)}
//               className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdChevronRight />
//             </button>

//             <button
//               disabled={page === totalPages}
//               onClick={() => setPage(totalPages)}
//               className="p-2 border rounded hover:bg-gray-100 disabled:opacity-40"
//             >
//               <MdLastPage />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MdSearch, MdDownload, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import BulkImportButton from "components/common/BulkImportButton";
import SampleDownloadButton from "components/common/SampleDownloadButton";
import { getProductByCompany, deleteProduct } from "api/product.api";
import ProductsTable from "components/products/ProductsTable";
import { InputField } from "components/FormFields";
import CustomButton from "components/CustomButton";
import Alert from "components/common/Alert";
import SideDrawerModal from "components/SideDrawerModal";
import ViewProductDetails from "components/products/ViewProductDetails";
import { isObjectCompletelyFilled } from "../../../utils/common";
import Modal from "components/common/Modal";

export default function Products() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [alert, setAlert] = useState("");
  const [userId, setUserId] = useState("69579c6190a653b640e65639");
  const [role, setRole] = useState("admin");
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [paginationInfo, setPaginationInfo] = useState({
    totalProducts: 0,
    totalPages: 1,
  });
  const abortControllerRef = useRef(null);
  const [showIncompleteProfileModal, setShowIncompleteProfileModal] = useState(false);
  const [loginData, setLoginData] = useState(null)

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    setLoginData(userData)
    if (userData._id) {
      setUserId(userData._id);
    }
    if (userData.role) {
      setRole(userData.role);
    }
    if (userData.role.toLowerCase() === "exhibitor") {
      const parentObj = userData.parentData;
      const mandatoryFields = {
        title: parentObj.title,
        exhibitor_category: parentObj.exhibitor_category,
        country: parentObj.country,
        overview: parentObj.overview,
        phone_number: parentObj.phone_number,
        logo_image: parentObj.logo_image,
        banner_image: parentObj.banner_image,
      };
      const isComplete = isObjectCompletelyFilled(mandatoryFields || {});
      // If validation has any errors, route to edit profile page; otherwise route to exhibitor dashboard
      if (!isComplete) {
        console.log("isComplete", isComplete);
        setShowIncompleteProfileModal(true);
      }
    }
  }, []);

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  // Fetch products
  const fetchData = useCallback(async () => {
    if (!selectedOrganizer) return;

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      setLoading(true);
      const res = await getProductByCompany(selectedOrganizer, {
        page,
        limit,
        search: debouncedSearch,
        signal: controller.signal,
      });

      const payload = res?.data || {};
      const list =
        payload.products ||
        payload.data ||
        (Array.isArray(payload) ? payload : []);

      setData(list);
      setPaginationInfo({
        totalProducts:
          payload.pagination?.totalProducts || payload.total || list.length,
        totalPages: payload.pagination?.totalPages || payload.totalPages || 1,
      });
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") return;
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  // Client-side search filter fallback
  const filteredData = data.filter((item) => {
    return [
      item.product_name,
      item.price,
      item.status,
      item.exhibitor_id?.title,
      item.product_category_id?.title,
    ]
      .join(" ")
      .toLowerCase()
      .includes(debouncedSearch.toLowerCase());
  });

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((item, idx) => item._id || idx));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDelete = async (id) => {
    await deleteProduct(id, {
      is_deleted: true,
      deleted_by: userId,
    });
    setAlert("Product deleted successfully");
    fetchData();
  };

  const handleExportCSV = () => {
    const exportData =
      selectedRows.length > 0
        ? filteredData.filter((item, idx) =>
            selectedRows.includes(item._id || idx)
          )
        : filteredData;

    if (!exportData.length) return;

    const headers = [
      "Product Name",
      "Price",
      "Exhibitor",
      "Product Category",
      "Status",
    ];
    const safeStr = (val) => String(val || "").replace(/"/g, '""');

    const rows = exportData.map((p) => [
      `"${safeStr(p.product_name)}"`,
      `"${safeStr(p.price)}"`,
      `"${safeStr(p.exhibitor_id?.title)}"`,
      `"${safeStr(p.product_category_id?.title)}"`,
      `"${safeStr(p.status)}"`,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `products_${
        selectedRows.length > 0 ? "selected" : "all"
      }_${Date.now()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const productView = (data) => {
    setSelectedProduct(data);
    setIsViewOpen(true);
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search products..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          {role !== "exhibitor" && (
            <>
              <CustomButton
                label={
                  selectedRows.length > 0
                    ? `Export Selected (${selectedRows.length})`
                    : "Export CSV"
                }
                icon={MdDownload}
                iconPos="left"
                variant="outline"
                color="#1A1A1A"
                borderColor="#02a9e0"
                disabled={filteredData.length === 0}
                onClick={handleExportCSV}
              />

              {/* <SampleDownloadButton module="products" /> */}

              <BulkImportButton
                module="products"
                label="Import Products"
                onSuccess={fetchData}
                companyId={selectedOrganizer}
              />
            </>
          )}

          <CustomButton
            label="Add Product"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => navigate("/admin/products/create")}
          />
        </div>
      </div>

      {alert && (
        <Alert type="success" message={alert} onClose={() => setAlert("")} />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading products...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <ProductsTable
            data={data}
            startIndex={(page - 1) * limit}
            onRefresh={fetchData}
            onDelete={handleDelete}
            selectedRows={selectedRows}
            onSelectRow={handleSelectRow}
            onSelectAll={handleSelectAll}
            viewButton={productView}
            role={role}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalProducts}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}
      <SideDrawerModal
        isOpen={isViewOpen}
        onClose={() => setIsViewOpen(false)}
        title={selectedProduct?.product_name || "Master Company Details"}
        width="600px"
      >
        <ViewProductDetails data={selectedProduct} />
      </SideDrawerModal>
      <Modal
        open={showIncompleteProfileModal}
        onClose={() => {}} // Empty function prevents closing on backdrop click
        showClose={false} // Hide top X button
        maxWidth="max-w-md"
      >
        <div className="flex flex-col items-center p-2 text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-2xl text-amber-600">
            ⚠️
          </div>

          <h3 className="mb-2 text-xl font-bold text-gray-900">
            Profile Incomplete
          </h3>

          <p className="mb-6 text-sm leading-relaxed text-gray-600">
            First complete your profile to access product management and other
            portal features.
          </p>
          
          <CustomButton
            label="Complete Profile"
            variant="solid"
            color="#02a9e0"
            onClick={() => navigate(`/admin/exhibitors/edit/${loginData.parentId}`)}
          />
        </div>
      </Modal>
    </TablePageLayout>
  );
}
